import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import Carousel1Image1 from "../assets/Page3L1.webp";
import Carousel1Image2 from "../assets/Page3L2.webp";
import Carousel1Image3 from "../assets/Page3L3.webp";
import Carousel2Image1 from "../assets/Page3RB1.webp";
import Carousel2Image2 from "../assets/Page3RB2.webp";
import RA from "../assets/Page3RA.webp";

//@ts-ignore
import RC from "../assets/Page3RC.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2, Carousel1Image3];
const carousel2Images = [Carousel2Image1, Carousel2Image2];

const Page2 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9.1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "35.5vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel1Images} />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                    borderRight: {
                      xs: "none",
                      sm: ".5vh solid #fff",
                    },
                    display: "flex",
                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        paddingRight: "2vw",
                        paddingLeft: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.5vh",
                          lg: "1.8vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "5vh" },
                      },
                    }}
                  >
                    In the heart of the home, the living room offers a warm and
                    inviting space bathed in natural light from expansive
                    windows, creating a cozy atmosphere perfect for unwinding.
                    The seamless flow to the ground patio provides a private
                    escape, surrounded by greenery, ideal for morning coffee or
                    quiet evening relaxation. With its blend of modern style and
                    intimate charm, this space perfectly balances practicality
                    and comfort, making it a versatile haven for both
                    entertaining and everyday living.
                  </Typography>
                </Grid>
              </Grid>
              {/* LC/LB */}
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: { xs: "36vh", sm: "50vh" },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      backgroundImage: `url('${RA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  />
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                    height: {
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "45vh", sm: "50vh" },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "bottom",
                      }}
                      src={RC}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "36.5vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel2Images} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page2;
